import { NAVY, SLATE, WHITE_TEXT } from 'styles/Colors';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import Diversity1OutlinedIcon from '@mui/icons-material/Diversity1Outlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import React from 'react';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';

const whiteBackgroundStyle = {
  position: 'relative',
  background: WHITE_TEXT,
  // width: '20rem',
  display: 'flex',
  flex: '1',
  borderRadius: '1.25rem',
  margin: '2rem 1rem 2rem'
};

const contentStyle = {
  borderRadius: 3,
  display: 'flex',
  flexDirection: 'column',
  fontFamily: 'Arimo',
  margin: '0 auto',
  position: 'relative',
  padding: '2rem',
  maxWidth: '50rem'
};

const iconContainerStyle = {
  background: WHITE_TEXT,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  left: '50%',
  position: 'absolute',
  transform: 'translate(-50%, -40%)',
  height: '7.375rem',
  width: '7.375rem'
};

const iconStyle = {
  color: NAVY,
  width: '4rem',
  height: '4rem',
  paddingTop: '15%'
};

const titleStyle = {
  color: NAVY,
  fontSize: '1.125rem',
  fontWeight: 700,
  marginTop: '2rem',
  marginBottom: '1.5rem',
  textAlign: 'center'
};

const subtextStyle = {
  fontSize: '1rem',
  color: SLATE,
  marginBottom: '1rem'
};

const desktopStyle = {};

const threeItemRowStyle = {
  display: 'flex',
  flexDirection: 'row',
  maxWidth: '75rem'
};

const oneItemRowStyle = {
  display: 'flex',
  flexDirection: 'row',
  maxWidth: '75rem',
  textAlign: 'center'
};

const supStyle = {
  verticalAlign: 'super',
  fontSize: '0.6rem'
};

function DesktopSectionContainer({ icon, title, subtext }) {
  const Icon = icon;
  return (
    <div css={whiteBackgroundStyle}>
      <div css={iconContainerStyle}>
        <Icon css={iconStyle} />
      </div>

      <div css={contentStyle}>
        <h1 css={titleStyle}>{title}</h1>
        <div css={subtextStyle}>{subtext}</div>
      </div>
    </div>
  );
}

function DesktopSection() {
  return (
    <div css={desktopStyle}>
      <div css={threeItemRowStyle}>
        <DesktopSectionContainer
          icon={EventAvailableOutlinedIcon}
          title='Same-Day Funding Available'
          subtext={
            <p>
              If approved, you may receive money in your account as soon as the
              same business day!<span css={supStyle}>1</span>
            </p>
          }
        />
        <DesktopSectionContainer
          icon={Diversity1OutlinedIcon}
          title='Referral Rewards'
          subtext='You could earn a $50 gift card* for a qualifying referral to OppLoans.'
        />
        <DesktopSectionContainer
          icon={SpeedOutlinedIcon}
          title='FICO® Score'
          subtext={
            <p>
              OppLoans only does a soft credit check so applying won’t
              negatively impact your FICO® score.
              <span css={supStyle}>2</span>
            </p>
          }
        />
      </div>
      <div css={threeItemRowStyle}>
        <DesktopSectionContainer
          icon={SupportAgentOutlinedIcon}
          title='Loan Support at Every Step'
          subtext='Our top-rated Customer Advocates are available to provide support at every step of the application process. We succeed when you do!'
        />
        <DesktopSectionContainer
          icon={FindInPageOutlinedIcon}
          title='No Hidden Fees'
          subtext='No origination fee, no application fee, no prepayment fees.'
        />
        <DesktopSectionContainer
          icon={EventRepeatOutlinedIcon}
          title='Repayment Schedule'
          subtext='Predictable and easy-to-read payment schedule.'
        />
      </div>
      <div css={oneItemRowStyle}>
        <DesktopSectionContainer
          icon={AccountBalanceOutlinedIcon}
          title='Build Credit History'
          subtext={
            <p>
              We report your payment history with us to the three major credit
              bureaus, so every on-time payment you make may help boost your
              credit history.<span css={supStyle}>6</span>
            </p>
          }
        />
      </div>
    </div>
  );
}

export default DesktopSection;
